import axios from "axios"
import { useEffect, useMemo, useState } from "react"
import { useAsync } from "react-use"
import { useContractRead } from "wagmi"
import { erc20TransferAbi } from "../constant"

export interface User {
  user_id: string
  identity_number: string
  full_name: string
  avatar_url: string
}

axios.defaults.baseURL = process.env.NODE_ENV === "development" ? "http://localhost:8234/" : "https://telegram.mixinwallet.com/"

export const useUser = (userId: string) =>
  useAsync(async () => {
    const { data } = await axios.get<User>(`users/${userId}`)
    return data
  }, [userId])

export interface Asset {
  asset_id: string
  name: string
  symbol: string
  destination: string
  tag: string
  asset_key: string
  icon_url: string
  chain_icon_url: string
}

export const useAsset = (userId: string, assetId: string) =>
  useAsync(async () => {
    const { data } = await axios.get<Asset>(`asset?user=${userId}&asset=${assetId}`)
    return data
  }, [])

export const useDecimal = (address?: string) => {
  const [decimal, setDecimals] = useState<number>()

  const [data, read] = useContractRead(
    {
      addressOrName: address || "",
      contractInterface: erc20TransferAbi,
    },
    "decimals"
  )

  useMemo(() => {
    if (!data?.data) return
    setDecimals(data?.data as unknown as number | undefined)
  }, [data.data])

  useEffect(() => {
    if (!address) return
    if (data.data) return
    read()
  }, [address, data.data, read])

  return {
    ...data,
    loading: !decimal,
    data: decimal,
  }
}
